import { ClosingPosState } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { postClosingPos } from './closingPos.services';

export const initialState: ClosingPosState = {
    data: {},
    status: "loading",
    error: {}
}

export const ClosingPosSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postClosingPos.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(postClosingPos.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(postClosingPos.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const ClosingPosReducer = ClosingPosSlice.reducer